/**
 * Client-side preview of the portal code/key a label will produce. Must stay
 * in step with slugifyPortalKey in fusion-server's util/portal-admin.util.js —
 * the server is authoritative and re-derives it on save; this only spares the
 * admin a round trip to see what they will get.
 */
export function portalSlug(label: string): string {
    if (!label) return '';
    return String(label)
        .normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
